// extracted by mini-css-extract-plugin
export default {"headerIcon":"HomeIcon_headerIcon__3Nxmt"};